import { useState } from "react";
import { toast } from "sonner";
import { Search, Loader2 } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function TrackWidget({ compact = false }) {
    const [value, setValue] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onSubmit = (e) => {
        e.preventDefault();
        const v = value.trim().toUpperCase();
        if (v.length < 4) {
            toast.error("Enter a valid container number");
            return;
        }
        setLoading(true);
        // Navigate to track page with query
        setTimeout(() => {
            navigate(`/track?cn=${encodeURIComponent(v)}`);
            setLoading(false);
        }, 250);
    };

    return (
        <form
            onSubmit={onSubmit}
            data-testid="track-widget"
            className={`flex items-center gap-2 ${
                compact
                    ? "max-w-lg"
                    : "max-w-2xl mx-auto"
            }`}
        >
            <div className="flex-1 relative">
                <Search
                    size={16}
                    className="absolute left-4 top-1/2 -translate-y-1/2 text-zinc-500"
                />
                <input
                    type="text"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    placeholder="Enter container number e.g. MSCU1234567"
                    className="input-dark w-full rounded-full pl-11 pr-4 py-3 text-sm"
                    data-testid="track-widget-input"
                    autoComplete="off"
                />
            </div>
            <button
                type="submit"
                disabled={loading}
                className="btn-primary disabled:opacity-60 py-3"
                data-testid="track-widget-submit"
            >
                {loading ? <Loader2 size={16} className="animate-spin" /> : "Track"}
            </button>
        </form>
    );
}
